export default __webpack_public_path__ + "MentiaCompanion2024.png";